import API from "shared/services/Api";
import { ISpecialist } from "shared/types";

export const getSpecialist = async (
  state: string,
  insurance: number,
  city: string,
  neighborhood: string,
  typeProvider: string,
  region?: string,
): Promise<ISpecialist> =>
  API.get(
    `specialty?${state && `state=${state}&`}insurance=${insurance}${
      city && `&city=${city}`
    }${region && `&region=${region}`}${
      neighborhood && `&neighborhood=${neighborhood}`
    }${typeProvider && `&typeProvider=${typeProvider}`}`,
  );
